import "./app.e0278e2b.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aEIUa", function(module, exports) {

$parcel$export(module.exports, "loadingIndicator", () => $7c2078fabb716a6f$export$f10e6b4aaa94c253);
/**
 * Show a loading state only when there is genuinely something to wait for.
 *
 * ── What was wrong ───────────────────────────────────────────────────────────
 *
 * The four pages that fetch their content shipped `<div id="loading">Loading…`
 * visible in the HTML, and hid it once the fetch resolved. That is right when
 * the fetch is slow and wrong the rest of the time, and the rest of the time is
 * most of the time.
 *
 * Measured on the live feed, on a repeat visit: `domContentLoaded` at 299ms,
 * the request for /api/v1/posts starting at 303ms and finishing at 305ms — two
 * milliseconds, served from the service worker's cache. The loader was on
 * screen from HTML parse until the module graph finished loading and running.
 * It was never waiting for data. It was waiting for JavaScript, with the answer
 * already in cache, and it flashed for roughly two hundred milliseconds every
 * single visit.
 *
 * ── What this does ───────────────────────────────────────────────────────────
 *
 * The element starts hidden in the markup, and is revealed only if the work is
 * still unfinished after a threshold. A fetch that resolves from cache never
 * reveals it; a cold visit, where the same request took over a second, does.
 *
 * That also fixes the announcement. These elements carry `role="status"` and
 * `aria-live="polite"`, so a screen reader announced "Loading…" on every visit
 * regardless. Now it is announced when it is true.
 *
 * ── On the threshold ─────────────────────────────────────────────────────────
 *
 * 250ms. Below roughly a tenth of a second a response reads as instant, and up
 * to a few tenths it reads as responsive; a spinner inside that window adds
 * noise and no information. Past it, silence starts to read as broken.
 *
 * It is deliberately not zero. A threshold of zero is the current behaviour
 * with extra steps.
 */ /** @type {number} */ const $7c2078fabb716a6f$var$DEFAULT_DELAY_MS = 250;
function $7c2078fabb716a6f$export$f10e6b4aaa94c253(element, delayMs = $7c2078fabb716a6f$var$DEFAULT_DELAY_MS) {
    if (!element) return ()=>{};
    element.hidden = true;
    const timer = setTimeout(()=>{
        element.hidden = false;
    }, delayMs);
    return ()=>{
        clearTimeout(timer);
        element.hidden = true;
    };
}

});

parcelRegister("aSNdN", function(module, exports) {

$parcel$export(module.exports, "lightbox", () => $7ec520e42d422785$export$c2b330519424b9e8);
// Minimal single-image lightbox — click a post/reply photo to view it full-size.
// Self-contained: injects its own styles and DOM on first use.
//
// Built on <dialog>. The previous version was a div with role="dialog" and
// aria-modal="true", which promises behaviour the browser then has to be told
// to provide: focus stayed on the page behind, Tab walked straight out of the
// open lightbox, and nothing restored focus on close. showModal() gives all of
// that — the focus trap, the inert background, the ::backdrop and Escape — from
// the platform, and deletes the code that was half-implementing it.
/** @type {HTMLDialogElement | null} */ let $7ec520e42d422785$var$dialog = null;
let $7ec520e42d422785$var$imgEl, $7ec520e42d422785$var$captionEl;
function $7ec520e42d422785$var$ensureBuilt() {
    if ($7ec520e42d422785$var$dialog) return;
    const style = document.createElement('style');
    style.textContent = `
    .sa-lightbox {
      border: 0;
      padding: 2em 1em;
      max-width: 100vw;
      max-height: 100vh;
      width: 100%;
      height: 100%;
      background: transparent;
      overflow: hidden;
    }
    /* <dialog> is display:none until open, so this replaces the old
       .active class entirely \u{2014} the open state is now the element's own. */
    .sa-lightbox[open] {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sa-lightbox::backdrop {
      background: rgba(0, 0, 0, 0.9);
    }
    .sa-lightbox img {
      max-width: 100%;
      max-height: 85vh;
      object-fit: contain;
      display: block;
      border-radius: var(--radius, 4px);
    }
    .sa-lightbox-caption {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.85em;
      text-align: center;
      margin-block-start: 0.75em;
    }
    .sa-lightbox-close {
      position: absolute;
      top: 1em;
      right: 1em;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: white;
      width: 2.25em;
      height: 2.25em;
      border-radius: 50%;
      font-size: 1.1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sa-lightbox-close:hover { background: rgba(255, 255, 255, 0.2); }
    .sa-lightbox-figure { display: flex; flex-direction: column; align-items: center; max-width: 100%; }
  `;
    document.head.appendChild(style);
    $7ec520e42d422785$var$dialog = document.createElement('dialog');
    $7ec520e42d422785$var$dialog.className = 'sa-lightbox';
    $7ec520e42d422785$var$dialog.setAttribute('aria-label', 'Media viewer');
    $7ec520e42d422785$var$dialog.innerHTML = `
    <button class="sa-lightbox-close" aria-label="Close">\u{2715}</button>
    <figure class="sa-lightbox-figure">
      <img alt="">
      <figcaption class="sa-lightbox-caption"></figcaption>
    </figure>
  `;
    document.body.appendChild($7ec520e42d422785$var$dialog);
    $7ec520e42d422785$var$imgEl = $7ec520e42d422785$var$dialog.querySelector('img');
    $7ec520e42d422785$var$captionEl = $7ec520e42d422785$var$dialog.querySelector('.sa-lightbox-caption');
    $7ec520e42d422785$var$dialog.querySelector('.sa-lightbox-close').addEventListener('click', $7ec520e42d422785$var$close);
    // Click-outside-to-close. The dialog fills the viewport so that its
    // ::backdrop can be styled, which means "outside" is the dialog's own
    // padding — anything that is not the figure or the close button.
    $7ec520e42d422785$var$dialog.addEventListener('click', (event)=>{
        if (event.target === $7ec520e42d422785$var$dialog) $7ec520e42d422785$var$close();
    });
    // Escape is handled by the browser, which fires 'cancel' then 'close'. The
    // scroll lock is released in the 'close' handler so it lifts however the
    // dialog was dismissed.
    $7ec520e42d422785$var$dialog.addEventListener('close', ()=>{
        document.body.style.overflow = '';
    });
}
/**
 * @param {string} src
 * @param {string} [caption]
 */ function $7ec520e42d422785$var$open(src, caption = '') {
    $7ec520e42d422785$var$ensureBuilt();
    $7ec520e42d422785$var$imgEl.src = src;
    $7ec520e42d422785$var$imgEl.alt = caption;
    $7ec520e42d422785$var$captionEl.textContent = caption;
    $7ec520e42d422785$var$dialog.showModal();
    document.body.style.overflow = 'hidden';
}
function $7ec520e42d422785$var$close() {
    if ($7ec520e42d422785$var$dialog?.open) $7ec520e42d422785$var$dialog.close();
}
const $7ec520e42d422785$export$c2b330519424b9e8 = {
    open: $7ec520e42d422785$var$open,
    close: $7ec520e42d422785$var$close
};

});

parcelRegister("egRyG", function(module, exports) {

$parcel$export(module.exports, "uploadToCloudinary", () => $a63c1aeba6c78780$export$ba8726098bbb8aef);
/**
 * media.js — uploading to Cloudinary, signed.
 *
 * Previously each page built its own FormData with `upload_preset` read from
 * `process.env.CLOUDINARY_UPLOAD_PRESET`. Parcel inlines those values at build
 * time, so the preset and cloud name were literals in the public bundles —
 * enough for anyone to upload to this Cloudinary account from anywhere, with no
 * sign-in required.
 *
 * Now the browser holds no upload credential at all. It asks the server for a
 * one-shot signature, which requires a valid session, and sends that instead.
 */ 
var $36CJS = parcelRequire("36CJS");
async function $a63c1aeba6c78780$export$ba8726098bbb8aef(file) {
    const { cloudName: cloudName, apiKey: apiKey, timestamp: timestamp, signature: signature } = await (0, $36CJS.api).uploads.signature();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('api_key', apiKey);
    fd.append('timestamp', timestamp);
    fd.append('signature', signature);
    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
        method: 'POST',
        body: fd
    });
    if (!res.ok) {
        const detail = await res.json().catch(()=>({}));
        throw new Error(detail?.error?.message || `Upload failed (${res.status})`);
    }
    return res.json();
}

});

parcelRegister("70R4S", function(module, exports) {
module.exports = import.meta.resolve("dJajv");

});

parcelRegister("gxv0g", function(module, exports) {

$parcel$export(module.exports, "GOTRUE_API_URL", () => $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1);
$parcel$export(module.exports, "initIdentityWidget", () => $c0a7c6fff4310ada$export$8c53c87b78e6fdd9);
$parcel$export(module.exports, "loadIdentityWidget", () => $c0a7c6fff4310ada$export$1259559fefbb46c);
$parcel$export(module.exports, "loadIdentityWidgetIfTokenPresent", () => $c0a7c6fff4310ada$export$267690839c122cee);
// Split out from auth-modal.js so pages with no sign-in UI (index, shows,
// studio) don't have to pull in the full custom auth modal — which builds
// and injects its whole login/signup DOM into the page as an import
// side-effect — just to initialize the Netlify Identity widget.
/**
 * This site's Identity (GoTrue) endpoint.
 *
 * Derived from wherever the page is served rather than hardcoded. The literal
 * production URL that used to live here meant a deploy preview authenticated
 * against production across origins — and, once this code is shared, that any
 * other band's deployment would silently sign users in against *this* band's
 * Identity instance.
 *
 * Locally this needs `netlify dev`, which serves /.netlify/identity on the dev
 * origin — the same thing the /api routes already require. Under a plain
 * `parcel serve` there is no Identity endpoint to talk to either way.
 */ const $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1 = `${window.location.origin}/.netlify/identity`;
function $c0a7c6fff4310ada$export$8c53c87b78e6fdd9() {
    window.netlifyIdentity?.init({
        APIUrl: $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1
    });
}
/**
 * The URL fragments Netlify Identity uses to hand a token to the page.
 *
 * These arrive from an email — confirm your address, reset your password,
 * accept an invite, confirm an address change. Visiting the link does not
 * confirm anything server-side; it drops the reader here with the token in the
 * hash, and only the initialised widget exchanges it for a session.
 */ const $c0a7c6fff4310ada$var$TOKEN_HASHES = [
    'confirmation_token=',
    'recovery_token=',
    'invite_token=',
    'email_change_token='
];
function $c0a7c6fff4310ada$export$d42ad5fbe912eace(hash = window.location.hash) {
    return $c0a7c6fff4310ada$var$TOKEN_HASHES.some((token)=>hash.includes(token));
}
/** @type {Promise<void> | null} */ let $c0a7c6fff4310ada$var$loading = null;
function $c0a7c6fff4310ada$export$1259559fefbb46c() {
    if ($c0a7c6fff4310ada$var$loading) return $c0a7c6fff4310ada$var$loading;
    $c0a7c6fff4310ada$var$loading = new Promise((resolve)=>{
        if (window.netlifyIdentity) return resolve();
        const script = document.createElement('script');
        script.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
        script.async = true;
        script.addEventListener('load', ()=>{
            $c0a7c6fff4310ada$export$8c53c87b78e6fdd9();
            resolve();
        });
        // Ad blockers and offline both land here. Callers degrade rather than hang.
        script.addEventListener('error', ()=>resolve());
        document.head.appendChild(script);
    });
    return $c0a7c6fff4310ada$var$loading;
}
function $c0a7c6fff4310ada$export$267690839c122cee() {
    if (!$c0a7c6fff4310ada$export$d42ad5fbe912eace()) return Promise.resolve();
    return $c0a7c6fff4310ada$export$1259559fefbb46c();
}

});


var $3qsiv = parcelRequire("3qsiv");

var $aEIUa = parcelRequire("aEIUa");

var $aSNdN = parcelRequire("aSNdN");

var $egRyG = parcelRequire("egRyG");

var $5IRmI = parcelRequire("5IRmI");

var $36CJS = parcelRequire("36CJS");
async function $b52ad2eef3b323cb$var$validateMediaFile(file) {
    const maxSize = 52428800; // 50 MB
    if (file.size > maxSize) throw new Error('File must be under 50 MB');
    const allowed = [
        'image/',
        'video/',
        'audio/'
    ];
    if (!allowed.some((t)=>file.type.startsWith(t))) throw new Error('Only images, videos, and audio files are allowed');
    if (file.type.startsWith('video/')) await new Promise((resolve, reject)=>{
        const video = document.createElement('video');
        video.preload = 'metadata';
        const src = URL.createObjectURL(file);
        video.onloadedmetadata = ()=>{
            URL.revokeObjectURL(src);
            if (video.duration > 300) reject(new Error('Videos must be under 5 minutes'));
            else resolve();
        };
        video.onerror = ()=>{
            URL.revokeObjectURL(src);
            reject(new Error('Could not read video metadata'));
        };
        video.src = src;
    });
}
function $b52ad2eef3b323cb$var$createMediaPreviewEl(file) {
    const wrap = document.createElement('div');
    const objectUrl = URL.createObjectURL(file);
    if (file.type.startsWith('image/')) {
        const img = document.createElement('img');
        img.src = objectUrl;
        img.alt = 'Media preview';
        wrap.appendChild(img);
    } else if (file.type.startsWith('video/')) {
        const video = document.createElement('video');
        video.controls = true;
        video.preload = 'metadata';
        video.setAttribute('playsinline', '');
        const source = document.createElement('source');
        source.src = objectUrl;
        video.appendChild(source);
        wrap.appendChild(video);
    } else if (file.type.startsWith('audio/')) {
        const audio = document.createElement('audio');
        audio.controls = true;
        const source = document.createElement('source');
        source.src = objectUrl;
        audio.appendChild(source);
        wrap.appendChild(audio);
    }
    return wrap;
}
// Detect media type from a Cloudinary (or generic) URL.
// Note: Cloudinary stores audio uploaded via the `auto` resource type under
// /video/upload/ — so we must check the file extension *before* checking the
// path segment to avoid treating audio files as videos.
function $b52ad2eef3b323cb$var$isAudioUrl(url) {
    const lower = url.toLowerCase();
    // Explicit audio extensions take priority (Cloudinary auto-upload stores
    // audio under /video/upload/ but keeps the original extension in the URL)
    if (lower.endsWith('.m4a') || lower.endsWith('.mp3') || lower.endsWith('.wav') || lower.endsWith('.ogg') || lower.endsWith('.aac') || lower.endsWith('.flac')) return true;
    // Cloudinary raw uploads are also audio (no extension rewriting)
    if (url.includes('/raw/upload/')) return true;
    // Cloudinary /video/upload/ URLs that contain an audio MIME hint
    if (url.includes('/video/upload/') && lower.includes('audio')) return true;
    return false;
}
function $b52ad2eef3b323cb$var$isVideoUrl(url) {
    // Only treat as video if it's under /video/upload/ AND not an audio file
    return url.includes('/video/upload/') && !$b52ad2eef3b323cb$var$isAudioUrl(url);
}
// Insert Cloudinary transformation params after /upload/ in a URL.
// Handles URLs that already contain a transform segment (e.g. /upload/v123456/)
// by inserting before the version/path, not duplicating the segment.
function $b52ad2eef3b323cb$var$cloudinaryOptimize(url, width) {
    if (!url || !url.includes('res.cloudinary.com')) return url;
    // Avoid double-inserting transforms if the URL already has them
    if (url.includes('/upload/f_auto')) return url;
    return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
}
function $b52ad2eef3b323cb$var$buildMediaElement(mediaUrl, className) {
    if (!mediaUrl) return null;
    const container = document.createElement('div');
    container.className = className;
    if ($b52ad2eef3b323cb$var$isAudioUrl(mediaUrl)) {
        // Audio — render as <audio> player
        const audio = document.createElement('audio');
        audio.controls = true;
        audio.style.width = '100%';
        audio.style.display = 'block';
        const source = document.createElement('source');
        source.src = mediaUrl;
        audio.appendChild(source);
        container.appendChild(audio);
    } else if ($b52ad2eef3b323cb$var$isVideoUrl(mediaUrl)) {
        // Video — render as <video> player; don't preload until user interacts
        const video = document.createElement('video');
        video.controls = true;
        video.preload = 'none';
        video.setAttribute('playsinline', '');
        video.setAttribute('loading', 'lazy');
        const source = document.createElement('source');
        source.src = mediaUrl;
        video.appendChild(source);
        container.appendChild(video);
    } else {
        // Image — serve via Cloudinary with format/quality auto + responsive srcset
        const img = document.createElement('img');
        img.alt = 'Attached media';
        img.loading = 'lazy';
        img.decoding = 'async';
        // Responsive srcset: 400w for mobile, 760w covers the max container width
        img.srcset = [
            `${$b52ad2eef3b323cb$var$cloudinaryOptimize(mediaUrl, 400)} 400w`,
            `${$b52ad2eef3b323cb$var$cloudinaryOptimize(mediaUrl, 760)} 760w`
        ].join(', ');
        // Container is capped at 760px (max-width of board-container)
        img.sizes = '(max-width: 760px) 100vw, 760px';
        img.src = $b52ad2eef3b323cb$var$cloudinaryOptimize(mediaUrl, 760); // fallback
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', ()=>{
            (0, $aSNdN.lightbox).open($b52ad2eef3b323cb$var$cloudinaryOptimize(mediaUrl, 1600), '');
        });
        container.appendChild(img);
    }
    return container;
}
// Re-render the signed-in affordances when the modal reports a sign-in.
// There is no local session copy to update — session.js reads storage.
window.addEventListener('auth-modal:login', ()=>{
    $b52ad2eef3b323cb$var$updateModalAuth();
    $b52ad2eef3b323cb$var$refreshDeleteButtons();
    $b52ad2eef3b323cb$var$refreshReplyForms();
});
// ─── DOM refs ─────────────────────────────────────────────────────────────────
const $b52ad2eef3b323cb$var$threadsList = document.getElementById('threads-list');
const $b52ad2eef3b323cb$var$loadingEl = document.getElementById('loading');
const $b52ad2eef3b323cb$var$emptyState = document.getElementById('empty-state');
const $b52ad2eef3b323cb$var$errorState = document.getElementById('error-state');
const $b52ad2eef3b323cb$var$newThreadBtn = document.getElementById('new-thread-btn');
const $b52ad2eef3b323cb$var$modal = document.getElementById('new-thread-modal');
const $b52ad2eef3b323cb$var$modalClose = document.getElementById('modal-close');
const $b52ad2eef3b323cb$var$modalCancel = document.getElementById('modal-cancel');
const $b52ad2eef3b323cb$var$authGate = document.getElementById('board-auth-gate');
const $b52ad2eef3b323cb$var$threadForm = document.getElementById('new-thread-form');
const $b52ad2eef3b323cb$var$threadTitle = document.getElementById('thread-title');
const $b52ad2eef3b323cb$var$threadBody = document.getElementById('thread-body');
const $b52ad2eef3b323cb$var$threadSubmit = document.getElementById('thread-submit-btn');
const $b52ad2eef3b323cb$var$formStatus = document.getElementById('form-status');
const $b52ad2eef3b323cb$var$loginBtnBoard = document.getElementById('login-btn-board');
// ─── Auth helpers ─────────────────────────────────────────────────────────────
// Board code asks "is anyone signed in" rather than for a user object.
function $b52ad2eef3b323cb$var$currentUser() {
    const email = (0, $5IRmI.currentEmail)();
    return email ? {
        email: email
    } : null;
}
function $b52ad2eef3b323cb$var$getDisplayName(email) {
    if (!email) return 'Anonymous';
    return email.split('@')[0];
}
// ─── Date formatter ───────────────────────────────────────────────────────────
function $b52ad2eef3b323cb$var$formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
// ─── Auth gate in modal ───────────────────────────────────────────────────────
function $b52ad2eef3b323cb$var$updateModalAuth() {
    const user = $b52ad2eef3b323cb$var$currentUser();
    if (user) {
        $b52ad2eef3b323cb$var$authGate.hidden = true;
        $b52ad2eef3b323cb$var$threadForm.hidden = false;
    } else {
        $b52ad2eef3b323cb$var$authGate.hidden = false;
        $b52ad2eef3b323cb$var$threadForm.hidden = true;
    }
}
// ─── Modal open/close ─────────────────────────────────────────────────────────
function $b52ad2eef3b323cb$var$openModal() {
    $b52ad2eef3b323cb$var$updateModalAuth();
    $b52ad2eef3b323cb$var$modal.showModal();
    $b52ad2eef3b323cb$var$modal.querySelector('input, textarea')?.focus();
}
function $b52ad2eef3b323cb$var$closeModal() {
    if ($b52ad2eef3b323cb$var$modal.open) $b52ad2eef3b323cb$var$modal.close();
    $b52ad2eef3b323cb$var$threadForm.reset();
    $b52ad2eef3b323cb$var$formStatus.textContent = '';
    // Reset media state
    $b52ad2eef3b323cb$var$selectedThreadMedia = null;
    if ($b52ad2eef3b323cb$var$mediaPreviewEl) $b52ad2eef3b323cb$var$mediaPreviewEl.innerHTML = '';
    if ($b52ad2eef3b323cb$var$mediaPreviewWrap) $b52ad2eef3b323cb$var$mediaPreviewWrap.hidden = true;
    if ($b52ad2eef3b323cb$var$mediaStatusEl) {
        $b52ad2eef3b323cb$var$mediaStatusEl.textContent = '';
        $b52ad2eef3b323cb$var$mediaStatusEl.className = '';
    }
}
$b52ad2eef3b323cb$var$newThreadBtn.addEventListener('click', $b52ad2eef3b323cb$var$openModal);
$b52ad2eef3b323cb$var$modalClose.addEventListener('click', $b52ad2eef3b323cb$var$closeModal);
$b52ad2eef3b323cb$var$modalCancel.addEventListener('click', $b52ad2eef3b323cb$var$closeModal);
$b52ad2eef3b323cb$var$modal.addEventListener('click', (e)=>{
    if (e.target === $b52ad2eef3b323cb$var$modal) $b52ad2eef3b323cb$var$closeModal();
});
// Escape is handled by <dialog>; 'cancel' fires first, so the form reset in
// closeModal() still runs however the dialog is dismissed.
$b52ad2eef3b323cb$var$modal.addEventListener('cancel', ()=>$b52ad2eef3b323cb$var$closeModal());
// Open the custom auth modal when the "Sign In / Create Account" button is clicked
$b52ad2eef3b323cb$var$loginBtnBoard.addEventListener('click', ()=>{
    // Close the thread modal first so modals don't stack
    $b52ad2eef3b323cb$var$closeModal();
    (0, $3qsiv.authModal).open('login');
});
// ─── Re-render all open reply form sections to reflect current auth state ─────
function $b52ad2eef3b323cb$var$refreshReplyForms() {
    document.querySelectorAll('.reply-form-section').forEach((el)=>{
        const threadId = el.closest('.thread-card')?.dataset.threadId;
        if (threadId) $b52ad2eef3b323cb$var$renderReplyFormSection(el, threadId);
    });
}
// ─── Netlify Identity events (keep for users already signed in via widget) ────
window.addEventListener('load', ()=>{
    const identity = window.netlifyIdentity;
    if (!identity) return;
    identity.on('init', ()=>{
        $b52ad2eef3b323cb$var$updateModalAuth();
        $b52ad2eef3b323cb$var$refreshDeleteButtons();
        $b52ad2eef3b323cb$var$refreshReplyForms();
    });
    identity.on('login', ()=>{
        $b52ad2eef3b323cb$var$updateModalAuth();
        $b52ad2eef3b323cb$var$refreshDeleteButtons();
        $b52ad2eef3b323cb$var$refreshReplyForms();
    });
    identity.on('logout', ()=>{
        // The widget's session is gone; drop the custom-modal one too.
        (0, $5IRmI.clearSession)();
        $b52ad2eef3b323cb$var$updateModalAuth();
        $b52ad2eef3b323cb$var$refreshDeleteButtons();
        $b52ad2eef3b323cb$var$refreshReplyForms();
    });
});
// Show or hide all delete buttons based on current auth state
function $b52ad2eef3b323cb$var$refreshDeleteButtons() {
    const show = !!$b52ad2eef3b323cb$var$currentUser();
    document.querySelectorAll('.thread-delete-btn, .reply-delete-btn').forEach((btn)=>{
        btn.hidden = !show;
    });
}
// ─── Build a reply card element ───────────────────────────────────────────────
function $b52ad2eef3b323cb$var$buildReplyCard(reply, threadId) {
    const card = document.createElement('div');
    card.className = 'reply-card';
    card.dataset.replyId = reply.id;
    const header = document.createElement('div');
    header.className = 'reply-header';
    const author = document.createElement('span');
    author.className = 'reply-author';
    author.textContent = $b52ad2eef3b323cb$var$getDisplayName(reply.author);
    const dateMeta = document.createElement('span');
    dateMeta.className = 'reply-date';
    dateMeta.textContent = $b52ad2eef3b323cb$var$formatDate(reply.createdAt);
    const deleteBtn = document.createElement('button');
    deleteBtn.className = 'reply-delete-btn';
    deleteBtn.textContent = 'Delete';
    deleteBtn.hidden = !$b52ad2eef3b323cb$var$currentUser();
    deleteBtn.setAttribute('aria-label', 'Delete this reply');
    deleteBtn.addEventListener('click', ()=>$b52ad2eef3b323cb$var$handleDeleteReply(threadId, reply.id, card));
    header.appendChild(author);
    header.appendChild(dateMeta);
    header.appendChild(deleteBtn);
    const body = document.createElement('p');
    body.className = 'reply-body';
    body.textContent = reply.body;
    card.appendChild(header);
    // Media attachment
    if (reply.mediaUrl) {
        const mediaEl = $b52ad2eef3b323cb$var$buildMediaElement(reply.mediaUrl, 'reply-media');
        if (mediaEl) card.appendChild(mediaEl);
    }
    card.appendChild(body);
    return card;
}
// ─── Delete a reply ───────────────────────────────────────────────────────────
async function $b52ad2eef3b323cb$var$handleDeleteReply(threadId, replyId, cardEl) {
    if (!confirm('Delete this reply?')) return;
    const btn = cardEl.querySelector('.reply-delete-btn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Deleting\u2026";
    }
    try {
        await (0, $36CJS.api).board.replies.remove(threadId, replyId);
        cardEl.remove();
        const threadCard = $b52ad2eef3b323cb$var$threadsList.querySelector(`[data-thread-id="${threadId}"]`);
        if (threadCard) {
            // Recount from the DOM so the value is always accurate
            const replyCount = threadCard.querySelectorAll('.reply-card').length;
            const toggleBtn = threadCard.querySelector('.toggle-replies-btn');
            if (toggleBtn) {
                toggleBtn.dataset.replyCount = replyCount;
                const isOpen = !!threadCard.querySelector('.replies-container.visible');
                const arrow = isOpen ? "\u25BE" : "\u25B8";
                toggleBtn.textContent = replyCount === 0 ? `Replies (0) ${arrow}` : `${replyCount} repl${replyCount === 1 ? 'y' : 'ies'} ${arrow}`;
            }
            // Show the "no replies" message when the list is now empty
            const repliesListEl = threadCard.querySelector('.replies-list');
            const noRepliesEl = threadCard.querySelector('.no-replies');
            if (repliesListEl && noRepliesEl && !repliesListEl.children.length) noRepliesEl.hidden = false;
            // Collapse the replies container when there are no replies left
            if (replyCount === 0) {
                const repliesContainer = threadCard.querySelector('.replies-container');
                if (repliesContainer) {
                    repliesContainer.classList.remove('visible');
                    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
                }
            }
        }
    } catch (err) {
        console.error('[board] delete reply error:', err);
        alert(`Could not delete reply: ${err.message}`);
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Delete';
        }
    }
}
// ─── Delete a thread ──────────────────────────────────────────────────────────
async function $b52ad2eef3b323cb$var$handleDeleteThread(threadId, cardEl) {
    if (!confirm('Delete this thread and all its replies? This cannot be undone.')) return;
    const btn = cardEl.querySelector('.thread-delete-btn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = "Deleting\u2026";
    }
    try {
        await (0, $36CJS.api).board.threads.remove(threadId);
        cardEl.remove();
        if (!$b52ad2eef3b323cb$var$threadsList.children.length) $b52ad2eef3b323cb$var$emptyState.hidden = false;
    } catch (err) {
        console.error('[board] delete thread error:', err);
        alert(`Could not delete thread: ${err.message}`);
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Delete thread';
        }
    }
}
// ─── Fetch and render replies into a container ────────────────────────────────
async function $b52ad2eef3b323cb$var$loadReplies(threadId, repliesListEl, noRepliesEl, loadingEl) {
    loadingEl.hidden = false;
    noRepliesEl.hidden = true;
    repliesListEl.innerHTML = '';
    try {
        const replies = await (0, $36CJS.api).board.replies.list(threadId);
        loadingEl.hidden = true;
        // ── Reconcile the toggle-button label with the actual fetched count ───
        // The stored thread.replyCount can drift out of sync (e.g. if replies were
        // deleted directly in the blob store, or a race condition occurred during
        // creation). Always use the authoritative count from the fetched array.
        const threadCard = repliesListEl.closest('.thread-card');
        if (threadCard) {
            const toggleBtn = threadCard.querySelector('.toggle-replies-btn');
            if (toggleBtn) {
                const actualCount = replies.length;
                toggleBtn.dataset.replyCount = actualCount;
                // Button is open at this point (we just expanded it)
                toggleBtn.textContent = actualCount === 0 ? "Replies (0) \u25BE" : `${actualCount} repl${actualCount === 1 ? 'y' : 'ies'} \u{25BE}`;
            }
        }
        if (!replies.length) {
            noRepliesEl.hidden = false;
            return;
        }
        replies.forEach((reply)=>repliesListEl.appendChild($b52ad2eef3b323cb$var$buildReplyCard(reply, threadId)));
    } catch (err) {
        loadingEl.hidden = true;
        repliesListEl.innerHTML = `<p class="reply-status error">Could not load replies.</p>`;
        console.error('[board] loadReplies error:', err);
    }
}
// ─── Build the reply form section (auth-aware) ────────────────────────────────
function $b52ad2eef3b323cb$var$renderReplyFormSection(container, threadId) {
    container.innerHTML = '';
    const user = $b52ad2eef3b323cb$var$currentUser();
    if (!user) {
        const authMsg = document.createElement('div');
        authMsg.className = 'auth-required';
        authMsg.innerHTML = `Sign in to leave a reply &nbsp;
      <button class="btn btn-sm btn-primary" style="margin-inline-start:0.5em;" data-login-btn>Sign In</button>`;
        authMsg.querySelector('[data-login-btn]').addEventListener('click', ()=>{
            (0, $3qsiv.authModal).open('login');
        });
        container.appendChild(authMsg);
        return;
    }
    const heading = document.createElement('h4');
    heading.textContent = 'Leave a Reply';
    container.appendChild(heading);
    const form = document.createElement('form');
    form.className = 'reply-form';
    const textarea = document.createElement('textarea');
    textarea.placeholder = "Write your reply\u2026";
    textarea.required = true;
    // ── Media input for replies ──────────────────────────────────────────────
    const mediaWrap = document.createElement('div');
    mediaWrap.className = 'reply-media-wrap';
    const mediaLabel = document.createElement('label');
    mediaLabel.textContent = 'Media (optional)';
    mediaLabel.style.cssText = 'display:block; font-size:0.85em; opacity:0.7; margin-block-end:0.3em;';
    const replyMediaInput = document.createElement('input');
    replyMediaInput.type = 'file';
    replyMediaInput.accept = 'image/*,video/*,audio/*';
    replyMediaInput.setAttribute('aria-label', 'Attach photo, video, or audio to reply');
    // `font: inherit` rather than naming a family: the typeface is the site's
    // choice, and a licensed Typekit name written into shared code both hardcodes
    // this band's identity and would fail to load anywhere without that kit.
    replyMediaInput.style.cssText = "width:100%; background:transparent; border:1px dashed rgba(255,255,255,0.25); color:white; font: inherit; font-size:0.9rem; padding:0.4em; border-radius:4px; cursor:pointer;";
    const replyMediaPreviewWrap = document.createElement('div');
    replyMediaPreviewWrap.hidden = true;
    replyMediaPreviewWrap.style.marginBlockStart = '0.5em';
    const replyMediaPreview = document.createElement('div');
    replyMediaPreview.className = 'reply-media-preview';
    const removeReplyMediaBtn = document.createElement('button');
    removeReplyMediaBtn.type = 'button';
    removeReplyMediaBtn.className = 'btn btn-sm';
    removeReplyMediaBtn.textContent = 'Remove Media';
    removeReplyMediaBtn.style.cssText = "margin-block-start:0.4em; background:rgba(245,168,168,0.12); border-color:rgba(245,168,168,0.35); color:#f5a8a8;";
    replyMediaPreviewWrap.appendChild(replyMediaPreview);
    replyMediaPreviewWrap.appendChild(removeReplyMediaBtn);
    const replyMediaStatus = document.createElement('p');
    replyMediaStatus.className = 'reply-media-status';
    mediaWrap.appendChild(mediaLabel);
    mediaWrap.appendChild(replyMediaInput);
    mediaWrap.appendChild(replyMediaPreviewWrap);
    mediaWrap.appendChild(replyMediaStatus);
    let selectedReplyMedia = null;
    replyMediaInput.addEventListener('change', async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        replyMediaStatus.textContent = '';
        replyMediaStatus.className = 'reply-media-status';
        selectedReplyMedia = null;
        try {
            await $b52ad2eef3b323cb$var$validateMediaFile(file);
            selectedReplyMedia = file;
            replyMediaPreview.innerHTML = '';
            replyMediaPreview.appendChild($b52ad2eef3b323cb$var$createMediaPreviewEl(file));
            replyMediaPreviewWrap.hidden = false;
        } catch (err) {
            replyMediaStatus.textContent = `\u{2715} ${err.message}`;
            replyMediaStatus.className = 'reply-media-status error';
            replyMediaInput.value = '';
        }
    });
    removeReplyMediaBtn.addEventListener('click', ()=>{
        selectedReplyMedia = null;
        replyMediaInput.value = '';
        replyMediaPreview.innerHTML = '';
        replyMediaPreviewWrap.hidden = true;
        replyMediaStatus.textContent = '';
        replyMediaStatus.className = 'reply-media-status';
    });
    // ── Actions row ──────────────────────────────────────────────────────────
    const actions = document.createElement('div');
    actions.className = 'reply-form-actions';
    const submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    submitBtn.className = 'btn btn-primary btn-sm';
    submitBtn.textContent = 'Post Reply';
    const status = document.createElement('p');
    status.className = 'reply-status';
    actions.appendChild(submitBtn);
    form.appendChild(textarea);
    form.appendChild(mediaWrap);
    form.appendChild(actions);
    form.appendChild(status);
    container.appendChild(form);
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const body = textarea.value.trim();
        if (!body) return;
        submitBtn.disabled = true;
        submitBtn.textContent = "Posting\u2026";
        status.textContent = '';
        status.className = 'reply-status';
        try {
            let mediaUrl = '';
            if (selectedReplyMedia) {
                replyMediaStatus.textContent = "Uploading media\u2026";
                replyMediaStatus.className = 'reply-media-status uploading';
                try {
                    const result = await (0, $egRyG.uploadToCloudinary)(selectedReplyMedia);
                    mediaUrl = result.secure_url;
                    replyMediaStatus.textContent = '';
                    replyMediaStatus.className = 'reply-media-status';
                } catch (err) {
                    replyMediaStatus.textContent = `\u{2715} Media upload failed: ${err.message}`;
                    replyMediaStatus.className = 'reply-media-status error';
                // Post without media rather than blocking
                }
            }
            const reply = await (0, $36CJS.api).board.replies.create(threadId, {
                body: body,
                mediaUrl: mediaUrl
            });
            const repliesListEl = container.closest('.replies-container')?.querySelector('.replies-list');
            const noRepliesEl = container.closest('.replies-container')?.querySelector('.no-replies');
            if (repliesListEl) {
                if (noRepliesEl) noRepliesEl.hidden = true;
                repliesListEl.appendChild($b52ad2eef3b323cb$var$buildReplyCard(reply, threadId));
            }
            const card = container.closest('.thread-card');
            if (card) {
                const toggleBtn = card.querySelector('.toggle-replies-btn');
                if (toggleBtn) {
                    const count = parseInt(toggleBtn.dataset.replyCount || '0', 10) + 1;
                    toggleBtn.dataset.replyCount = count;
                    toggleBtn.textContent = `${count} repl${count === 1 ? 'y' : 'ies'} \u{25BE}`;
                }
            }
            // Reset reply form
            textarea.value = '';
            selectedReplyMedia = null;
            replyMediaInput.value = '';
            replyMediaPreview.innerHTML = '';
            replyMediaPreviewWrap.hidden = true;
            replyMediaStatus.textContent = '';
            replyMediaStatus.className = 'reply-media-status';
            status.textContent = 'Reply posted!';
            status.className = 'reply-status success';
            setTimeout(()=>{
                status.textContent = '';
            }, 3000);
        } catch (err) {
            console.error('[board] post reply error:', err);
            status.textContent = `Error: ${err.message}`;
            status.className = 'reply-status error';
        } finally{
            submitBtn.disabled = false;
            submitBtn.textContent = 'Post Reply';
        }
    });
}
// ─── Build a full thread card element ────────────────────────────────────────
function $b52ad2eef3b323cb$var$buildThreadCard(thread) {
    const card = document.createElement('div');
    card.className = 'thread-card';
    card.dataset.threadId = thread.id;
    const cardHeader = document.createElement('div');
    cardHeader.className = 'thread-card-header';
    const title = document.createElement('h3');
    title.className = 'thread-title';
    title.textContent = thread.title;
    const deleteThreadBtn = document.createElement('button');
    deleteThreadBtn.className = 'thread-delete-btn';
    deleteThreadBtn.textContent = 'Delete thread';
    deleteThreadBtn.hidden = !$b52ad2eef3b323cb$var$currentUser();
    deleteThreadBtn.setAttribute('aria-label', `Delete thread: ${thread.title}`);
    deleteThreadBtn.addEventListener('click', ()=>$b52ad2eef3b323cb$var$handleDeleteThread(thread.id, card));
    cardHeader.appendChild(title);
    cardHeader.appendChild(deleteThreadBtn);
    card.appendChild(cardHeader);
    const meta = document.createElement('div');
    meta.className = 'thread-meta';
    const authorSpan = document.createElement('span');
    authorSpan.textContent = $b52ad2eef3b323cb$var$getDisplayName(thread.author);
    const dateSpan = document.createElement('span');
    dateSpan.textContent = $b52ad2eef3b323cb$var$formatDate(thread.createdAt);
    meta.appendChild(authorSpan);
    meta.appendChild(dateSpan);
    card.appendChild(meta);
    // Media attachment
    if (thread.mediaUrl) {
        const mediaEl = $b52ad2eef3b323cb$var$buildMediaElement(thread.mediaUrl, 'thread-media');
        if (mediaEl) card.appendChild(mediaEl);
    }
    const preview = document.createElement('p');
    preview.className = 'thread-preview';
    preview.textContent = thread.body;
    card.appendChild(preview);
    const replyCount = thread.replyCount || 0;
    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'toggle-replies-btn';
    toggleBtn.dataset.replyCount = replyCount;
    toggleBtn.setAttribute('aria-expanded', 'false');
    toggleBtn.textContent = replyCount === 0 ? "Replies (0) \u25B8" : `${replyCount} repl${replyCount === 1 ? 'y' : 'ies'} \u{25B8}`;
    card.appendChild(toggleBtn);
    const repliesContainer = document.createElement('div');
    repliesContainer.className = 'replies-container';
    const repliesLoadingEl = document.createElement('p');
    repliesLoadingEl.className = 'replies-loading';
    repliesLoadingEl.textContent = "Loading replies\u2026";
    repliesLoadingEl.hidden = true;
    const noRepliesEl = document.createElement('p');
    noRepliesEl.className = 'no-replies';
    noRepliesEl.textContent = "No replies yet \u2014 be the first!";
    noRepliesEl.hidden = true;
    const repliesListEl = document.createElement('div');
    repliesListEl.className = 'replies-list';
    const replyFormSection = document.createElement('div');
    replyFormSection.className = 'reply-form-section';
    repliesContainer.appendChild(repliesLoadingEl);
    repliesContainer.appendChild(noRepliesEl);
    repliesContainer.appendChild(repliesListEl);
    repliesContainer.appendChild(replyFormSection);
    card.appendChild(repliesContainer);
    let repliesLoaded = false;
    toggleBtn.addEventListener('click', ()=>{
        const isOpen = repliesContainer.classList.contains('visible');
        if (isOpen) {
            repliesContainer.classList.remove('visible');
            toggleBtn.setAttribute('aria-expanded', 'false');
            const count = parseInt(toggleBtn.dataset.replyCount || '0', 10);
            toggleBtn.textContent = count === 0 ? "Replies (0) \u25B8" : `${count} repl${count === 1 ? 'y' : 'ies'} \u{25B8}`;
        } else {
            repliesContainer.classList.add('visible');
            toggleBtn.setAttribute('aria-expanded', 'true');
            const count = parseInt(toggleBtn.dataset.replyCount || '0', 10);
            toggleBtn.textContent = count === 0 ? "Replies (0) \u25BE" : `${count} repl${count === 1 ? 'y' : 'ies'} \u{25BE}`;
            if (!repliesLoaded) {
                repliesLoaded = true;
                $b52ad2eef3b323cb$var$loadReplies(thread.id, repliesListEl, noRepliesEl, repliesLoadingEl);
                $b52ad2eef3b323cb$var$renderReplyFormSection(replyFormSection, thread.id);
            }
        }
    });
    return card;
}
// ─── New thread form — media state & wiring ───────────────────────────────────
let $b52ad2eef3b323cb$var$selectedThreadMedia = null;
const $b52ad2eef3b323cb$var$threadMediaInput = document.getElementById('thread-media');
const $b52ad2eef3b323cb$var$mediaPreviewWrap = document.getElementById('media-preview-wrap');
const $b52ad2eef3b323cb$var$mediaPreviewEl = document.getElementById('media-preview');
const $b52ad2eef3b323cb$var$removeMediaBtn = document.getElementById('remove-media-btn');
const $b52ad2eef3b323cb$var$mediaStatusEl = document.getElementById('media-status');
$b52ad2eef3b323cb$var$threadMediaInput.addEventListener('change', async (e)=>{
    const file = e.target.files?.[0];
    if (!file) return;
    $b52ad2eef3b323cb$var$mediaStatusEl.textContent = '';
    $b52ad2eef3b323cb$var$mediaStatusEl.className = '';
    $b52ad2eef3b323cb$var$selectedThreadMedia = null;
    try {
        await $b52ad2eef3b323cb$var$validateMediaFile(file);
        $b52ad2eef3b323cb$var$selectedThreadMedia = file;
        $b52ad2eef3b323cb$var$mediaPreviewEl.innerHTML = '';
        $b52ad2eef3b323cb$var$mediaPreviewEl.appendChild($b52ad2eef3b323cb$var$createMediaPreviewEl(file));
        $b52ad2eef3b323cb$var$mediaPreviewWrap.hidden = false;
    } catch (err) {
        $b52ad2eef3b323cb$var$mediaStatusEl.textContent = `\u{2715} ${err.message}`;
        $b52ad2eef3b323cb$var$mediaStatusEl.className = 'error';
        $b52ad2eef3b323cb$var$threadMediaInput.value = '';
    }
});
$b52ad2eef3b323cb$var$removeMediaBtn.addEventListener('click', ()=>{
    $b52ad2eef3b323cb$var$selectedThreadMedia = null;
    $b52ad2eef3b323cb$var$threadMediaInput.value = '';
    $b52ad2eef3b323cb$var$mediaPreviewEl.innerHTML = '';
    $b52ad2eef3b323cb$var$mediaPreviewWrap.hidden = true;
    $b52ad2eef3b323cb$var$mediaStatusEl.textContent = '';
    $b52ad2eef3b323cb$var$mediaStatusEl.className = '';
});
// ─── New thread form submission ───────────────────────────────────────────────
$b52ad2eef3b323cb$var$threadForm.addEventListener('submit', async (e)=>{
    e.preventDefault();
    const title = $b52ad2eef3b323cb$var$threadTitle.value.trim();
    const body = $b52ad2eef3b323cb$var$threadBody.value.trim();
    if (!title || !body) return;
    $b52ad2eef3b323cb$var$threadSubmit.disabled = true;
    $b52ad2eef3b323cb$var$threadSubmit.textContent = "Posting\u2026";
    $b52ad2eef3b323cb$var$formStatus.textContent = '';
    try {
        let mediaUrl = '';
        if ($b52ad2eef3b323cb$var$selectedThreadMedia) {
            $b52ad2eef3b323cb$var$mediaStatusEl.textContent = "Uploading media\u2026";
            $b52ad2eef3b323cb$var$mediaStatusEl.className = 'uploading';
            try {
                const result = await (0, $egRyG.uploadToCloudinary)($b52ad2eef3b323cb$var$selectedThreadMedia);
                mediaUrl = result.secure_url;
                $b52ad2eef3b323cb$var$mediaStatusEl.textContent = '';
                $b52ad2eef3b323cb$var$mediaStatusEl.className = '';
            } catch (err) {
                $b52ad2eef3b323cb$var$mediaStatusEl.textContent = `\u{2715} Media upload failed: ${err.message}`;
                $b52ad2eef3b323cb$var$mediaStatusEl.className = 'error';
            // Continue posting without media rather than blocking
            }
        }
        const thread = await (0, $36CJS.api).board.threads.create({
            title: title,
            body: body,
            mediaUrl: mediaUrl
        });
        const card = $b52ad2eef3b323cb$var$buildThreadCard(thread);
        if ($b52ad2eef3b323cb$var$threadsList.firstChild) $b52ad2eef3b323cb$var$threadsList.insertBefore(card, $b52ad2eef3b323cb$var$threadsList.firstChild);
        else $b52ad2eef3b323cb$var$threadsList.appendChild(card);
        $b52ad2eef3b323cb$var$emptyState.hidden = true;
        $b52ad2eef3b323cb$var$closeModal();
    } catch (err) {
        console.error('[board] create thread error:', err);
        $b52ad2eef3b323cb$var$formStatus.textContent = `Error: ${err.message}`;
        $b52ad2eef3b323cb$var$formStatus.style.color = '#f5a8a8';
    } finally{
        $b52ad2eef3b323cb$var$threadSubmit.disabled = false;
        $b52ad2eef3b323cb$var$threadSubmit.textContent = 'Post Thread';
    }
});
// ─── Load all threads on page load ───────────────────────────────────────────
async function $b52ad2eef3b323cb$var$loadThreads() {
    const settled = (0, $aEIUa.loadingIndicator)($b52ad2eef3b323cb$var$loadingEl);
    try {
        const threads = await (0, $36CJS.api).board.threads.list();
        settled();
        if (!threads.length) {
            $b52ad2eef3b323cb$var$emptyState.hidden = false;
            return;
        }
        threads.forEach((thread)=>$b52ad2eef3b323cb$var$threadsList.appendChild($b52ad2eef3b323cb$var$buildThreadCard(thread)));
    } catch (err) {
        console.error('[board] loadThreads error:', err);
        settled();
        $b52ad2eef3b323cb$var$errorState.hidden = false;
    }
}
// ─── Silent background refresh ─────────────────────────────────────────────────
// Re-fetches and re-renders the thread list without disturbing the user —
// re-expands (and reloads replies for) any threads that were already open.
async function $b52ad2eef3b323cb$var$refreshThreadsSilently() {
    try {
        const threads = await (0, $36CJS.api).board.threads.list();
        const openThreadIds = Array.from($b52ad2eef3b323cb$var$threadsList.querySelectorAll('.thread-card')).filter((card)=>card.querySelector('.replies-container.visible')).map((card)=>card.dataset.threadId);
        $b52ad2eef3b323cb$var$threadsList.innerHTML = '';
        if (!threads.length) {
            $b52ad2eef3b323cb$var$emptyState.hidden = false;
            return;
        }
        $b52ad2eef3b323cb$var$emptyState.hidden = true;
        threads.forEach((thread)=>{
            const card = $b52ad2eef3b323cb$var$threadsList.appendChild($b52ad2eef3b323cb$var$buildThreadCard(thread));
            if (openThreadIds.includes(thread.id)) card.querySelector('.toggle-replies-btn')?.click();
        });
    } catch (err) {
        console.warn('[board] refreshThreadsSilently error:', err);
    }
}

// ─── Service Worker registration + messages ────────────────────────────────────
function $b52ad2eef3b323cb$var$registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register((parcelRequire("70R4S")), {
        scope: '/'
    }).catch((err)=>console.warn('[board] SW registration failed:', err));
}
function $b52ad2eef3b323cb$var$listenForSWMessages() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.addEventListener('message', (e)=>{
        const { type: type, url: url } = e.data || {};
        // The SW revalidated /api/board/threads in the background and found the
        // response actually changed — silently re-render instead of leaving
        // stale content on screen until the user manually reloads.
        if (type === 'API_UPDATED' && url?.includes('/api/board/threads')) $b52ad2eef3b323cb$var$refreshThreadsSilently();
    });
}
(async ()=>{
    // Refresh an expired session (if a refresh token is available) before the
    // auth-gated UI below (delete buttons, reply forms, auth bar) renders.
    await (0, $3qsiv.ensureFreshSession)();
    $b52ad2eef3b323cb$var$registerServiceWorker();
    $b52ad2eef3b323cb$var$listenForSWMessages();
    $b52ad2eef3b323cb$var$loadThreads();
    (0, $3qsiv.initAuthBar)();
})();


//# sourceMappingURL=community.a436bbf1.js.map
